import { useMemo } from "react";

import { useLocaleContext } from "../../i18n/locale-context";
import { ACCEPTED_LOCALES, DEFAULT_LOCALE } from "./events-locales";

export function useEventsLocale() {
  const { locale } = useLocaleContext();

  return useMemo(
    () => ACCEPTED_LOCALES[locale as keyof typeof ACCEPTED_LOCALES] ?? DEFAULT_LOCALE,
    [locale]
  );
}
